import { styled } from '@material-ui/core'
import Select from 'shared/components/Select'

const SELECT_MIN_WIDTH = 62

export const PaginationContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  padding: theme.spacing(2, 3, 2, 1),
  '& > *': {
    marginRight: theme.spacing(2),
  },
}))

export const RowsSelect = styled(Select)(({ theme }) => ({
  minWidth: SELECT_MIN_WIDTH,
  width: 'min-content',
  '& p': {
    marginRight: theme.spacing(),
  },
  '& svg': {
    marginRight: theme.spacing(0.5),
  },
  '& ul': {
    borderRadius: 20,
    overflow: 'hidden',
  },
}))
